<template><!-- svgo-optimised -->
<svg class="icon icon__mute" viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg">
<g>
<path d="M10.52 1.76c3.52 0 6.37 2.85 6.37 6.37s-2.85 6.37-6.37 6.37" stroke="#000000" stroke-miterlimit="10" stroke-width="2"/>
<path d="M10.52 5.61c1.39 0 2.52 1.13 2.52 2.52 0 1.39-1.13 2.52-2.52 2.52" stroke="#000000" stroke-miterlimit="10" stroke-width="2"/>
<path d="M0 8.74v2.74h4.48l3.91 4.42V.49L4.48 4.9H0v2.74" fill="#000000"/>
</g>
<defs><path d="M0 0h17.9v16.69H0z" fill="#000000"/></defs></svg></template>